import useAxios from "../../hooks/useAxios";

const useExternalAppService = () => {
  const axiosList = useAxios();
  const axiosCreate = useAxios();
  const axiosUpdate = useAxios();
  const axiosRotate = useAxios();
  const axiosDelete = useAxios();

  const getAllExternalApps = async () => {
    await axiosList.fetchData({
      url: `/xadmin/external-apps`,
      method: "GET",
    });
  };

  const createExternalApp = async (data) => {
    return await axiosCreate.fetchData({
      url: `/xadmin/external-apps`,
      method: "POST",
      data,
    });
  };

  const updateExternalApp = async (id, data) => {
    return await axiosUpdate.fetchData({
      url: `/xadmin/external-apps/${id}`,
      method: "PUT",
      data,
    });
  };

  const rotateToken = async (id) => {
    return await axiosRotate.fetchData({
      url: `/xadmin/external-apps/${id}/rotate`,
      method: "POST",
    });
  };

  const deleteExternalApp = async (id) => {
    return await axiosDelete.fetchData({
      url: `/xadmin/external-apps/${id}`,
      method: "DELETE",
    });
  };

  return {
    getAllExternalApps,
    listLoading: axiosList.loading,
    listResponse: axiosList.response,

    createExternalApp,
    createLoading: axiosCreate.loading,

    updateExternalApp,
    updateLoading: axiosUpdate.loading,

    rotateToken,
    rotateLoading: axiosRotate.loading,

    deleteExternalApp,
    deleteLoading: axiosDelete.loading,
  };
};

export default useExternalAppService;
